export const DEMO_LOT_STORAGE_KEY = "demo_lot_active";
export const DEMO_LOT_EVENT = "demo-lot-toggle";
export const DEMO_LOT_OFFSET = 40;

const isBrowser = typeof window !== "undefined";

export const isDemoLotActive = (): boolean => {
  if (!isBrowser) {
    return false;
  }
  try {
    return sessionStorage.getItem(DEMO_LOT_STORAGE_KEY) === "true";
  } catch (error) {
    console.warn("Unable to read demo lot mode from sessionStorage", error);
    return false;
  }
};

export const setDemoLotActive = (active: boolean) => {
  if (!isBrowser) {
    return;
  }

  const current = isDemoLotActive();
  if (current === active) {
    return;
  }

  try {
    if (active) {
      sessionStorage.setItem(DEMO_LOT_STORAGE_KEY, "true");
    } else {
      sessionStorage.removeItem(DEMO_LOT_STORAGE_KEY);
    }
  } catch (error) {
    console.warn("Unable to update demo lot mode in sessionStorage", error);
  }

  window.dispatchEvent(
    new CustomEvent<{ active: boolean }>(DEMO_LOT_EVENT, {
      detail: { active },
    })
  );
};
